import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class Notification extends Component {

    formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    calculateValue = (amount, price) => {
        // remove any ',' from the amount value
        amount = parseInt(amount.toString().replace(/\W/g, ''))
        return this.formatNumber((amount * price).toFixed(2))
    }

    render() {
        return (
            <Modal isOpen>
                <ModalHeader>Trade Execution Receipt</ModalHeader>
                <ModalBody>
                    Your { this.props.information.type === 'buy' ? 'ask' : 'bid' } for <b>{ this.props.information.company }</b> at <b>${ this.props.information.price }</b> for <b>{ this.props.information.amount }</b> shares was { this.props.information.type === 'buy' ? 'lifted' : 'hit' }. <br /><br /> This has a trade value of <b>${ this.calculateValue(this.props.information.amount, this.props.information.price) }</b>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={ (e) => this.props.deleteNotification(this.props.information) }>Done</Button>{' '}
                </ModalFooter>
            </Modal>
        );
    }
}

export default Notification;